module.exports = __webpack_public_path__ + "img/school_info_icon.0b5e1efe.svg";